import type { AddMyFilesToRequestBody } from "@nlc/shared-types";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue.ts";
import { addMyFilesToRequest } from "@/features/my-files/api/addMyFilesToRequest";

export function useSendMyFiles() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      body,
      requestId,
    }: {
      body: AddMyFilesToRequestBody;
      requestId: number;
    }) => addMyFilesToRequest(requestId, body),
    onError: (error: Error) => {
      if (error.message.includes("Invalid file name")) {
        toast.add(
          {
            description: error.message,
            title: "Filenames are invalid",
            type: "error",
          },
          {
            timeout: 5000,
          },
        );

        return;
      }
      toast.add({
        description: "Something went wrong",
        title: "Error",
        type: "error",
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["myFiles"],
      });
    },
  });
}
